import React from "react";

import Sharing from "@src/multiCustodian/components/SideNav/NavItem/icons/Sharing";

import { TooltipIcon } from "./BaseIconTooltip";

export const PeopleIconTooltip = () => {
  return (
    <TooltipIcon tooltipText={"This is shared with you"}>
      <Sharing />
    </TooltipIcon>
  );
};
